module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-chat-bubbles-3a954eb0ef208267faced4559aed6a9e.svg";